var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { injectIntl } from 'react-intl';
import OutsideClickHandler from 'react-outside-click-handler';
import { listItemMsg } from '../FormattedListValue';
import EnumSelect from '../input/EnumSelect';
import EditableToggle from './EditableToggle';
var EditableEnumSelect = function (_a) {
    var enumType = _a.enumType, onChange = _a.onChange, _b = _a.value, value = _b === void 0 ? null : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, intl = _a.intl, placeholder = _a.placeholder, allowNull = _a.allowNull, hideItems = _a.hideItems, customDisplayValue = _a.customDisplayValue;
    var displayValue = customDisplayValue !== null && customDisplayValue !== void 0 ? customDisplayValue : (value || value === 0 ? intl.formatMessage(listItemMsg(enumType, value)) : placeholder || '');
    return (_jsx(EditableToggle, __assign({ onSubmit: onChange, value: value, disabled: disabled, displayValue: displayValue }, { children: function (_a) {
            var inputValue = _a.inputValue, setInputValue = _a.setInputValue, submit = _a.submit;
            return (_jsx(OutsideClickHandler, __assign({ onOutsideClick: submit }, { children: _jsx(EnumSelect, { enumType: enumType, value: inputValue, onChange: function (v) { return setInputValue(v).then(submit); }, allowNull: allowNull, hideItems: hideItems }) })));
        } })));
};
export default injectIntl(EditableEnumSelect);
